import { render, staticRenderFns } from "./DashboardUsers.vue?vue&type=template&id=6567682e&scoped=true&"
import script from "./DashboardUsers.vue?vue&type=script&lang=js&"
export * from "./DashboardUsers.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUsers.vue?vue&type=style&index=0&id=6567682e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567682e",
  null
  
)

export default component.exports